import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/skill.css"; // Custom CSS for extra styling

const skills = [
  { name: "HTML", icon: "🌐" },
  { name: "CSS", icon: "🎨" },
  { name: "JavaScript", icon: "⚡" },
  { name: "React.js", icon: "⚛️" },
  { name: "Node.js", icon: "🟢" },
  { name: "MongoDB", icon: "🍃" },
  { name: "SQL", icon: "💾" },
  { name: "Dotnet Core Web API", icon: "🔷" },
  { name: "Angular", icon: "🅰️" },
];

const SkillsSection = () => {
  return (
    <div className="container text-center my-5">
      <h2 className="mb-4 text-white">My Skills</h2>
      <div className="row justify-content-center">
        {skills.map((skill, index) => (
          <div key={index} className="col-md-3 col-sm-6 mb-4">
            <div className="skill-card p-4 shadow-lg text-white">
              <div className="skill-icon mb-3">{skill.icon}</div>
              <h5>{skill.name}</h5>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsSection;
